export default __webpack_public_path__ + "static/media/circleLogo.b779aa6d.png";